import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild} from '@angular/core';
import {AnimationController, IonicModule, ModalController} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {register} from 'swiper/element/bundle';
import {TranslateModule} from '@ngx-translate/core';
import {ComponentsModule} from '../components.module';

@Component({
  standalone: true,
  selector: 'add-ascent',
  imports: [IonicModule, CommonModule, TranslateModule, ComponentsModule],
  templateUrl: 'PointsReceivedComponent.html',
  styleUrls: ['PointsReceivedComponent.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PointsReceivedComponent implements OnInit {

  @ViewChild('title', {static: true}) title: any;
  @ViewChild('subtitle', {static: true}) subtitle: any;
  @ViewChild('fist', {static: true}) fist: any;

  public pointsReceived: number = 0;

  constructor(
    private animationCtrl: AnimationController,
    private modalController: ModalController) {
    register();

  }

  ngOnInit(): void {
    this.intro();
  }


  private async intro() {
    const titleFadeIn = this.animationCtrl.create()
      .addElement(this.title?.nativeElement).addElement(this.subtitle?.nativeElement)
      .duration(700)
      .fromTo('opacity', '0', '1').afterClearStyles(['opacity']);
    const titleFadeOut = this.animationCtrl.create()
      .addElement(this.title?.nativeElement).addElement(this.subtitle?.nativeElement)
      .duration(700)
      .fromTo('opacity', '1', '0');
    const fistFadeOut = this.animationCtrl.create()
      .addElement(this.fist?.nativeElement)
      .duration(100)
      .fromTo('opacity', '1', '0');
    await titleFadeIn.play();
    await fistFadeOut.play();
    await titleFadeOut.play();
    await this.dismiss();
  }


  async dismiss() {
    await this.modalController.dismiss();
  }

}
